import { animateLetters, cleanupLetters } from '@/animations/global.js';

/**
 * Директива v-text-split
 * Разбивает текст на слова, оборачивает в <span class="letter2">
 * и запускает анимацию через animateLetters()
 *
 * Использование: <span v-text-split="$t('key')"></span>
 */
export const textSplit = {
  mounted(el, binding) {
    processTextSplit(el, binding.value);
  },
  updated(el, binding) {
    processTextSplit(el, binding.value);
  },
  beforeUnmount(el) {
    cleanupLetters(el);
  }
};

function processTextSplit(el, text) {
  // Проверяем тип и наличие текста
  if (!text || typeof text !== 'string') {
    return;
  }

  // Получаем предыдущий текст
  const prevText = el.dataset.originalText;

  // Если текст не изменился → ничего не делаем
  if (prevText === text) {
    return;
  }

  // Кешируем новый текст
  el.dataset.originalText = text;

  // Разбиваем текст на слова (поддержка кириллицы и других Unicode символов)
  const words = text.trim().match(/[^\s]+/g) || [];

  // Создаём span элементы для каждого слова
  const letters = words.map(word => {
    const span = document.createElement('span');
    span.className = 'letter2';
    span.textContent = word + ' ';
    return span;
  });

  // Заменяем содержимое элемента
  el.replaceChildren(...letters);

  // Запускаем анимацию
  animateLetters(el);
}
